// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Wallet as WalletIcon } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";

import { Box, Dialog, Typography, Button } from "@/components/core";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function HowCanIDeposit({ sx }: any) {
  const { t } = useTranslation("bank");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [value, setValue] = useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  function createData(name: any, description: any) {
    return { name, description };
  }

  // USD için Banka Bilgileri
  const rowsUSD = [
    createData(t("recipientBankName"), "Aktif Yatırım Bankası A.Ş"),
    createData(t("correspondentBank"), "IRVTUS3NXXX - THE BANK OF NEW YORK MELLON"),
    createData(t("swiftcode"), "CAYTTRISXXX"),
  ];

  // EUR için banka bilgileri
  const rowsEUR = [
    createData(t("recipientBankName"), "Aktif Yatırım Bankası A.S"),
    createData(t("correspondentBank"), "Novo Banco SA - BESCPTPL"),
    createData(t("swiftcode"), "CAYTTRISXXX"),
    createData(t("bankAddress"), "Avenida da Liberdade 195 1250-142, Lisbon/Portugal"),
    createData(t("bic"), "BESCPTPL"),
  ];

  return (
    <>
      <Button sx={sx} onClick={() => setDialogOpen(true)} onClose={() => setDialogOpen(false)}>
        <WalletIcon sx={{ verticalAlign: "middle", mr: 1 }} />
        {t("howCanIDepositMoney")}
      </Button>
      <Dialog
        defaultTitle
        onClick={() => setDialogOpen(true)}
        open={dialogOpen}
        title={t("howCanIDepositMoney")}
        onClose={() => setDialogOpen(false)}
      >
        <Tabs value={value} onChange={handleChange} centered>
          <Tab label="USD" {...a11yProps(0)} />
          <Tab label="EURO" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Typography variant="inherit" sx={{ m: 2 }}>
            {t("howCanIDepositMoneyDescription")}
          </Typography>
          <TableContainer>
            <Table>
              <TableBody>
                {rowsUSD.map((row) => (
                  <TableRow key={row.name} sx={{ "& td, & th": { border: 1 } }}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="inherit" sx={{ m: 2 }}>
            {t("howCanIDepositMoneyDescription")}
          </Typography>
          <TableContainer>
            <Table sx={{ minWidth: 300 }}>
              <TableBody>
                {rowsEUR.map((row) => (
                  <TableRow key={row.name} sx={{ "& td, & th": { border: 1 } }}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <Grid sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            sx={{ fontSize: 18, padding: 1, width: "20vw", mb: 3 }}
            onClick={() => setDialogOpen(false)}
          >
            {t("close")}
          </Button>
        </Grid>
      </Dialog>
    </>
  );
}

HowCanIDeposit.propTypes = {
  sx: PropTypes.object,
};
